const customSpanishMessages = {
  ra: {
    configurable: {
      customize: 'Personalizar',
    },
    auth: {
      auth_check_error: 'Por favor, inicia sesión para continuar',
      logout: 'Cerrar sesión',
      password: 'Contraseña',
      sign_in: 'Iniciar sesión',
      sign_in_error: 'Falló la autenticación, inténtalo de nuevo',
      user_menu: 'Perfil',
      username: 'Nombre de usuario',
    },
    action: {
      add_filter: 'Agregar filtro',
      apply: 'Aplicar',
      back: 'Volver',
      cancel: 'Cancelar',
      clear_input_value: 'Limpiar valor',
      clone: 'Clonar',
      close: 'Cerrar',
      create: 'Crear',
      delete: 'Eliminar',
      edit: 'Editar',
      export: 'Exportar',
      list: 'Lista',
      refresh: 'Actualizar',
      remove: 'Eliminar',
      remove_filter: 'Eliminar filtro',
      save: 'Guardar',
      search: 'Buscar',
      show: 'Mostrar',
      sort: 'Ordenar',
      undo: 'Deshacer',
      expand: 'Expandir',
      close_menu: 'Cerrar menú',
      open_menu: 'Abrir menú',
      toggle_theme: 'Cambiar tema',
      add: 'Agregar',
    },
    boolean: {
      true: 'Sí',
      false: 'No',
    },
    page: {
      create: 'Crear %{name}',
      dashboard: 'Panel de control',
      edit: '%{name} #%{id}',
      error: 'Algo salió mal',
      list: '%{name}',
      loading: 'Cargando',
      not_found: 'No encontrado',
      show: '%{name} #%{id}',
      page_range_info: '{from}–{to} de {count}',
      range_info: '{from}–{to} de {count}',
      empty: 'Página Vacia',
    },
    input: {
      file: {
        upload_several:
          'Arrastra algunos archivos para subir o haz clic para seleccionar uno.',
        upload_single:
          'Arrastra un archivo para subir o haz clic para seleccionarlo.',
      },
      image: {
        upload_several:
          'Arrastra algunas imágenes para subir o haz clic para seleccionar una.',
        upload_single:
          'Arrastra una imagen para subir o haz clic para seleccionarla.',
      },
      references: {
        all_missing: 'No se pueden encontrar los datos de referencia.',
        many_missing:
          'Al menos una de las referencias asociadas ya no está disponible.',
        single_missing: 'La referencia asociada ya no está disponible.',
      },
    },
    message: {
      about: 'Acerca de',
      are_you_sure: '¿Estás seguro?',
      bulk_delete_content:
        '¿Estás seguro de que deseas eliminar este %{name}? |||| ¿Estás seguro de que deseas eliminar estos %{smart_count} elementos?',
      bulk_delete_title:
        'Eliminar %{name} |||| Eliminar %{smart_count} %{name}',
      delete_content: '¿Estás seguro de que deseas eliminar este elemento?',
      delete_title: 'Eliminar %{name} #%{id}',
      details: 'Detalles',
      error: 'Ocurrió un error y tu solicitud no pudo completarse.',
      invalid_form:
        'El formulario no es válido. Por favor, verifica los errores.',
      loading: 'La página está cargando, por favor espera.',
      no: 'No',
      not_found:
        'O ingresaste una URL incorrecta o seguiste un enlace incorrecto.',
      yes: 'Sí',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      page_rows_per_page: 'Filas por página',
      next: 'Siguiente',
      prev: 'Anterior',
      skip_nav: 'Saltar al contenido',
      page_range_info: '{from}–{to} de {count}',
      range_info: '{from}–{to} de {count}',
    },
    notification: {
      http_error: 'Error del servidor',
      canceled: 'Acción cancelada',
      created: 'Elemento creado correctamente',
      deleted: 'Elemento eliminado correctamente',
      updated: 'Elemento actualizado correctamente',
      not_authorized: 'No tienes permisos para acceder a este recurso',
    },
    validation: {
      email: 'Debe ser un correo electrónico válido',
      maxLength: 'Debe tener %{max} caracteres o menos',
      maxValue: 'Debe ser %{max} o menos',
      minLength: 'Debe tener al menos %{min} caracteres',
      minValue: 'Debe ser %{min} o más',
      number: 'Debe ser un número',
      oneOf: 'Debe ser uno de: %{options}',
      regex: 'Debe coincidir con un formato específico',
      required: 'Requerido',
    },
  },
  surveys: {
    language: {
      es: 'Español',
      en: 'Inglés',
      it: 'Italiano',
      fr: 'Frances',
    },
    resources: {
      campaign: 'Campaña',
      campaigns: 'Campañas',
      user: 'Usuario',
      users: 'Usuarios',
      question: 'Pregunta',
      questions: 'Preguntas',
      response: 'Respuesta',
      responses: 'Respuestas',
      coreg: 'Corregistro',
      coregs: 'Corregistros',
      thematics: 'Temáticas',
      thematic: 'Temática',
      wscampaign: 'WS Campaña',
      wscampaigns: 'WS Campañas',
      dashboard: 'Dashboard',
      delivery: 'Delivery',
      deliveries: 'Deliveries',
    },
    actions: {
      show_question: 'Mostrar pregunta',
      edit_question: 'Editar pregunta',
      add_response: 'Añadir respuesta',
      new_coregs: 'Añadir Coreg',
      create_coregs: 'Crear Coreg',
      new_thematics: 'Añadir Temática',
      create_thematics: 'Crear Temática',
      new_wscampaign: 'Añadir WS Campaña',
      create_wscampaign: 'Crear WS Campaña',
    },
    wscampaigns: {
      url_help_title: 'Variables disponibles en la URL WS',
      url_help_intro:
        'Usa placeholders entre corchetes en la URL. El prefijo ws_ es opcional en datos de usuario (por ejemplo, [ws_email] o [email]).',
      url_help_user_title: 'Datos del participante',
      url_help_email: 'Email del usuario',
      url_help_name: 'Nombre',
      url_help_surname: 'Apellidos',
      url_help_phone: 'Teléfono',
      url_help_postal_code: 'Código postal',
      url_help_gender: 'Sexo',
      url_help_dob: 'Fecha de nacimiento',
      url_help_ip: 'IP registrada en el alta',
      url_help_questions_title: 'Respuestas de la encuesta',
      url_help_questions_desc:
        'Usa el fieldMD de cada pregunta (campo "Mdirector Field" en Preguntas). Ejemplo: si fieldMD es hijos, escribe [ws_hijos].',
      url_help_example:
        'Ejemplo: ...&EMAIL=[ws_email]&NOMBRE=[ws_name]&PREGUNTA4=[ws_hijos]&uip=[ws_ip]',
    },
    dashboard: {
      subtitle:
        'Gestiona campañas, preguntas y usuarios desde un panel centralizado.',
      quick_actions: 'Accesos rápidos',
    },
    menu: {
      management: 'Contenido',
      integrations: 'Integraciones',
      audience: 'Audiencia',
    },
    campaigns: {
      tab_summary: 'Resumen',
      tab_flow: 'Flujo de preguntas',
      tab_questions: 'Preguntas',
      tab_summary_form: 'Datos generales',
      tab_appearance: 'Apariencia',
      theme_background_help:
        'Color (#hex), gradiente CSS o URL de imagen. Genera campaign-{id}-css.css en el servidor.',
      theme_accent_color_help:
        'Color de acento (#hex) para título, borde y botón si no indicas cada uno. Ej: #BF041A',
      theme_title_color_help:
        'Color del título (#text-1). Vacío = color de acento.',
      theme_border_color_help:
        'Color del borde del área (#area). Vacío = color de acento.',
      theme_button_color_help:
        'Color del botón finalizar/siguiente. Vacío = color de acento.',
      logo_upload_label: 'Logo de la campaña',
      logo_upload_button: 'Subir logo',
      logo_upload_help: 'PNG, JPG, GIF o WEBP. Máximo 2 MB.',
      logo_upload_after_save:
        'Guarda la campaña primero para poder subir el logo.',
      logo_upload_success: 'Logo subido correctamente',
      logo_upload_error: 'No se pudo subir el logo',
      theme_survey_title_help:
        'Título principal de la encuesta. Vacío = texto por idioma.',
      theme_survey_subtitle_help:
        'Subtítulo de la encuesta. Vacío = texto por idioma.',
      theme_step2_title_help: 'Título del paso 2 (correo directo).',
      theme_step2_subtitle_help: 'Subtítulo del paso 2.',
      flow_title: 'Recorrido de la campaña',
      view_cards: 'Vista tarjetas',
      view_table: 'Vista tabla',
      response_type: 'Tipo de respuesta',
      question_count: '%{count} preguntas',
      first_question: 'Primera pregunta',
      no_questions_title: 'Sin preguntas asociadas',
      no_questions_hint:
        'Esta campaña solo recoge el formulario inicial y redirige directamente al thanks.',
      no_questions_short: 'Solo formulario',
      questions_hint:
        'Añade las preguntas raíz en orden. Déjalo vacío si la campaña no necesita encuesta.',
      step_of: 'Pregunta %{current} de %{total}',
      add_question: 'Añadir pregunta',
      select_question: 'Seleccionar pregunta…',
      no_more_questions: 'No hay más preguntas disponibles',
      questions_order: 'Orden del flujo',
      no_questions_in_form: 'Ninguna pregunta seleccionada todavía.',
    },
    common: {
      status: 'Estado',
      active: 'Alta',
      desactive: 'Baja',
      vip: 'Vip',
      standard: 'Standard',
      identify: 'Id',
      name: 'Nombre',
      country: 'País',
      registered: 'Registrado',
      registration_date: 'Fecha alta',
      origin: 'Origen',
      boolean: {
        yes: 'Sí',
        no: 'No',
      },
    },
    messages: {
      welcome: 'Bienvenido al administrador',
      update_success: 'La actualización se ha realizado correctamente',
      update_failure: 'Ocurrió un error al realizar la actualización',
      user_deactivated_by_admin: 'Usuario dado de baja por un administrador',
      data_loading: 'Cargando datos ...',
      data_error: 'Error cargando datos',
      chart_data_loading: 'Cargando datos del gráfico ...',
      chart_data_error: 'Error cargando datos del gráfico',
      forgot_password: '¿Olvidaste tu contraseña?',
      reset_password: 'Restablecer contraseña',
      reset_password_text:
        'Introduce el email asociado con tu cuenta y te enviaremos un email con instrucciones para restablecer tu contraseña.',
      confirm_password: 'Confirmar contraseña',
      create_password: 'Crear contraseña',
      create_password_text: 'Por favor, introduce una nueva contraseña.',
      change_password: 'Cambiar contraseña',
      change_password_success: 'Password changed successfully',
      change_password_error: 'Error on reset password',
      change_password_link_error: 'Link not valid',
      forgot_password_success:
        'An email will be sent with the instructions to reset your password',
      forgot_password_error: 'Error requesting the password change',
      send_instructions: 'Enviar instrucciones',
      exceptions: {
        ResourceUrlExistException: 'Ya existe un recurso con esta URL (%{url})',
      },
    },
    validations: {
      confirmPassword: 'Password must be the same as the confirm password',
    },
  },
}

export default customSpanishMessages
